import { useApi } from './useApi';
import api from '../lib/api';
import { subscribeDataVersion } from '../lib/dataVersion';

// The dataset's full date span ({ start, end }) — one shared source of truth so
// the DateRangeControl picker anchors its presets and bounds its custom inputs
// identically on every page.
//
// useApi doesn't cache, so memoise at module level: the first page to mount
// fetches, every later page (and re-mount) reuses the same result. The range
// only ever grows, so nothing needs invalidating within a session; a failed
// fetch is not kept, so the next mount simply retries.
let cached = null;   // resolved { start, end }
let inflight = null; // pending promise shared by concurrent mounts

// A sync can extend the range (a new day of data), so drop the memo when the
// data version bumps. Registered at import time, i.e. before any component
// subscribes, so the memo is already cleared when their fetchers re-run.
subscribeDataVersion(() => { cached = null; });

const fetchRange = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = Promise.resolve(api.dataRange())
      .then((d) => { cached = d; return d; })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export function useDataRange() {
  const dr = useApi(fetchRange, []);
  return dr.data || undefined;
}

export default useDataRange;
